document.addEventListener("DOMContentLoaded", function () {
  const timeContainer = document.getElementById("timeTiles");
  const locationInput = document.getElementById("locationSelect");
  const dateInput = document.getElementById("appointmentDate");
  const timeInput = document.getElementById("timeSlotSelect");
  const calendarWrapper = document.getElementById("calendarWrapper");
  const timeWrapper = document.querySelector(".time-picker");
  const defaultTimes = Array.from({ length: 18 }, (_, i) => `${(i + 5).toString().padStart(2, '0')}:00`);

  document.querySelector("form").addEventListener("keydown", function (event) {
    if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      event.preventDefault();
    }
  });

  const firebaseConfig = {
    apiKey: "AIzaSyDPDss1EyRZB2UESE0LidmS9Y5mqFa0zHs",
    authDomain: "statmed-booking.firebaseapp.com",
    databaseURL: "https://statmed-booking-default-rtdb.firebaseio.com",
    projectId: "statmed-booking",
    storageBucket: "statmed-booking.appspot.com",
    messagingSenderId: "916983779413",
    appId: "1:916983779413:web:eb87636ecfe761162284dc",
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  const db = firebase.database();
  const productId = window.productId || null;
  let locationConfig = {};
  let currentMonthOffset = 0;

  function getDayName(dateStr) {
    return new Date(dateStr + "T12:00:00").toLocaleDateString("en-US", { weekday: "long" });
  }

  function formatTime(time) {
    const [h, m] = time.split(":");
    const hour = parseInt(h);
    const ampm = hour >= 12 ? "PM" : "AM";
    return ((hour % 12) || 12) + ":" + m + " " + ampm;
  }

  async function fetchBlockedSlots() {
    const snapshot = await db.ref("bookings").get();
    return snapshot.exists() ? Object.keys(snapshot.val()) : [];
  }

  function renderEmptyCalendarGrid() {
    const today = new Date();
    const viewMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const nextMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1);

    const calendarTable = document.createElement("table");
    calendarTable.className = "calendar-grid";

    const monthLabel = document.createElement("caption");
    monthLabel.innerText = viewMonth.toLocaleString("default", { month: "long", year: "numeric" });
    calendarTable.appendChild(monthLabel);

    const headerRow = document.createElement("tr");
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  weekDays.forEach(day => {
    const th = document.createElement("th");
    th.innerText = day;
    headerRow.appendChild(th);
  });
  calendarTable.appendChild(headerRow);

let date = new Date(viewMonth);
date.setDate(1);

// Updated offset calculation:
const startOffset = date.getDay();
let row = document.createElement("tr");

// Add blank cells for any offset
for (let i = 0; i < startOffset; i++) {
  row.appendChild(document.createElement("td"));
}

    while (date < nextMonth) {
  const td = document.createElement("td");

      td.innerHTML = `<button class="date-button unavailable" disabled>${date.getDate()}</button>`;

      row.appendChild(td);

      if (date.getDay() === 6) {
        calendarTable.appendChild(row);
        row = document.createElement("tr");
      }

      date.setDate(date.getDate() + 1);
    }

    if (row.children.length > 0) {
      calendarTable.appendChild(row);
    }

    calendarWrapper.innerHTML = "";
    calendarWrapper.appendChild(calendarTable);
  }

  function renderTimeTiles(date, location, blockedKeys) {
  timeWrapper.classList.add("enabled");

  if (!date || !locationConfig[location]) {
    timeContainer.innerHTML = defaultTimes
      .map((time) => `<div class="time-tile disabled">${formatTime(time)}</div>`)
      .join("");
    return;
  }

  const config = locationConfig[location];
  const selectedDate = new Date(date);
  const now = new Date();
  const within24Hours = selectedDate - now < 24 * 60 * 60 * 1000;

  if (within24Hours) {
    timeContainer.innerHTML = `<div class="unavailable">Booking unavailable within 24 hours</div>`;
    return;
  }

  const weekday = getDayName(date);
  const timeOptions = config.customHours?.[date] || config.defaultHours?.[weekday] || [];
  timeContainer.innerHTML = "";

  timeOptions.forEach((time) => {
    const slotKey = `${date}_${time}`;
    const isBlocked = blockedKeys.some(key => key === slotKey && db.ref(`bookings/${slotKey}/location`).once("value").then(snap => snap.val() === location));

    const div = document.createElement("div");
    div.className = "time-tile" + (isBlocked ? " disabled" : "");
    div.dataset.value = time;
    div.innerText = `${formatTime(time)}\n${isBlocked ? "Booked up" : "1 remaining"}`;

    if (!isBlocked) {
      div.onclick = () => {
        document.querySelectorAll(".time-tile").forEach((el) => el.classList.remove("selected"));
        div.classList.add("selected");
        timeInput.value = time;
      };
    }

    timeContainer.appendChild(div);
  });
}


  function renderCalendarGrid(location, blockedKeys) {
    const config = locationConfig[location];
    if (!config) return;

    const today = new Date();
    const viewMonth = new Date(today.getFullYear(), today.getMonth() + currentMonthOffset, 1);
    const nextMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1);

    const calendarTable = document.createElement("table");
    calendarTable.className = "calendar-grid";

    const monthLabel = document.createElement("caption");
    monthLabel.innerText = viewMonth.toLocaleString("default", { month: "long", year: "numeric" });
    monthLabel.style.fontWeight = "bold";
    monthLabel.style.fontSize = "18px";
    monthLabel.style.marginBottom = "6px";
    calendarTable.appendChild(monthLabel);

    const headerRow = document.createElement("tr");
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  weekDays.forEach(day => {
    const th = document.createElement("th");
    th.innerText = day;
    headerRow.appendChild(th);
  });
  calendarTable.appendChild(headerRow);

    let date = new Date(viewMonth);
    date.setDate(1);
    const startOffset = date.getDay();
    let row = document.createElement("tr");
    for (let i = 0; i < startOffset; i++) {
      row.appendChild(document.createElement("td"));
    }

    while (date < nextMonth) {
      const dateStr = date.toISOString().split("T")[0];
      const weekday = getDayName(dateStr);
      const td = document.createElement("td");

      if (date < today.setHours(0, 0, 0, 0)) {
        td.innerHTML = `<button class="date-button unavailable" disabled>${date.getDate()}</button>`;
      } else {
        const availableTimes = config.customHours?.[dateStr] || config.defaultHours?.[weekday];
        const isBlocked = (config.blockedDates || []).includes(dateStr);
        let buttonClass = "date-button";

        if (isBlocked || !availableTimes || availableTimes.length === 0) {
          buttonClass += " unavailable";
        }

        td.innerHTML = `<button type="button" class="${buttonClass}" data-value="${dateStr}" ${buttonClass.includes("unavailable") ? "disabled" : ""}>${date.getDate()}</button>`;

        if (!buttonClass.includes("unavailable")) {
          td.querySelector("button").onclick = () => {
            document.querySelectorAll(".date-button").forEach((btn) => btn.classList.remove("selected"));
            td.querySelector("button").classList.add("selected");
            dateInput.value = dateStr;
            renderTimeTiles(dateStr, location, blockedKeys);
          };
        }
      }

      row.appendChild(td);
      if (date.getDay() === 6) {
        calendarTable.appendChild(row);
        row = document.createElement("tr");
      }

      date.setDate(date.getDate() + 1);
    }

    if (row.children.length > 0) {
      calendarTable.appendChild(row);
    }

    const navRow = document.createElement("div");
    navRow.style.textAlign = "center";
    navRow.style.marginTop = "10px";

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "calendar-nav-button";
    prevBtn.textContent = "← Previous Month";
    prevBtn.onclick = async () => {
      currentMonthOffset--;
      const blockedKeys = await fetchBlockedSlots();
      renderCalendarGrid(location, blockedKeys);
    };

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "calendar-nav-button";
    nextBtn.textContent = "→ Next Month";
    nextBtn.onclick = async () => {
      currentMonthOffset++;
      const blockedKeys = await fetchBlockedSlots();
      renderCalendarGrid(location, blockedKeys);
    };

    navRow.appendChild(prevBtn);
    navRow.appendChild(nextBtn);

    calendarWrapper.innerHTML = "";
    calendarWrapper.appendChild(calendarTable);
    calendarWrapper.appendChild(navRow);
  }

  db.ref(`config/${productId}`).once("value").then((snapshot) => {
    if (!snapshot.exists()) {
      console.error("❌ No config found for product ID:", productId);
      return;
    }
    locationConfig = snapshot.val();
    console.log("✅ Loaded locationConfig from Firebase:", locationConfig);
  });

  window.initCalendarListeners = async function () {
    const locationTiles = document.querySelectorAll(".location-tile");
    if (!locationTiles.length) {
      console.warn("⚠️ No location tiles found.");
      return;
    }

    const blockedKeys = await fetchBlockedSlots();

    locationTiles.forEach((tile) => {
      tile.addEventListener("click", async () => {
        locationTiles.forEach((t) => t.classList.remove("selected"));
        tile.classList.add("selected");

        const location = tile.dataset.value;
        locationInput.value = location;
        dateInput.value = "";
        timeInput.value = "";

        calendarWrapper.classList.remove("disabled");
        calendarWrapper.classList.add("enabled");

        timeWrapper.classList.remove("enabled");
        timeWrapper.classList.add("disabled");

        renderCalendarGrid(location, blockedKeys);
      });
    });
  };

  calendarWrapper.classList.add("disabled");
  timeWrapper.classList.add("disabled");

  renderEmptyCalendarGrid();

  timeContainer.innerHTML = defaultTimes
    .map((time) => `<div class="time-tile disabled">${formatTime(time)}</div>`)
    .join("");
});

window.addEventListener("load", function () {
  if (window.initCalendarListeners) {
    window.initCalendarListeners();
  }
});

document.querySelector('form').addEventListener('submit', async function (e) {
  const location = document.getElementById("locationSelect").value;
  const date = document.getElementById("appointmentDate").value;
  const time = document.getElementById("timeSlotSelect").value;

  if (!location || !date || !time) return;

  const slotKey = `${date}_${time}`;
  const bookingRef = db.ref(`bookings/${slotKey}`);

  try {
    const snapshot = await bookingRef.get();
    if (snapshot.exists()) {
      alert("This time slot has already been booked.");
      e.preventDefault();
      return;
    }

    await bookingRef.set({
      location: location,
      time: time,
      date: date,
      productId: productId,
      timestamp: firebase.database.ServerValue.TIMESTAMP
    });

    // Booking successfully saved, allow Shopify to process the form.
  } catch (err) {
    console.error("❌ Failed to save booking:", err);
    e.preventDefault();
    alert("Something went wrong while booking. Please try again.");
  }
});
